import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "@/contexts/CartContext";
import { Trash2 } from "lucide-react";

export default function Cart() {
    const { cart, updateCart, removeCart } = useCart();
    const nav = useNavigate();

    return (
        <div className="max-w-[1200px] mx-auto px-4 md:px-10 py-10" data-testid="cart-page">
            <h1 className="font-display text-5xl md:text-7xl tracking-tighter mb-8">Cart</h1>
            {cart.items.length === 0 ? (
                <div className="border-2 border-black p-16 text-center">
                    <p className="font-mono text-sm mb-4">Your cart is empty.</p>
                    <Link to="/shop" className="inline-block bg-black text-white px-6 py-3 font-mono uppercase text-xs tracking-widest" data-testid="cart-empty-shop">Continue Shopping</Link>
                </div>
            ) : (
                <div className="grid md:grid-cols-[1fr_360px] gap-10">
                    <div className="space-y-4">
                        {cart.items.map(it => (
                            <div key={`${it.product_id}-${it.size}`} className="border-2 border-black p-4 flex gap-4" data-testid={`cart-item-${it.product_id}`}>
                                <img src={it.image} alt={it.name} className="w-24 h-24 object-cover border-2 border-black" />
                                <div className="flex-1">
                                    <div className="font-display text-xl">{it.name}</div>
                                    <div className="font-mono text-xs uppercase text-neutral-500 mt-1">Size: {it.size} • ₹{Math.round(it.price)}</div>
                                    <div className="mt-3 flex items-center gap-3">
                                        <div className="inline-flex border-2 border-black">
                                            <button onClick={() => updateCart(it.product_id, it.size, it.quantity - 1)} className="px-3 py-1 border-r-2 border-black" data-testid={`cart-minus-${it.product_id}`}>−</button>
                                            <div className="px-4 py-1 font-mono">{it.quantity}</div>
                                            <button onClick={() => updateCart(it.product_id, it.size, it.quantity + 1)} className="px-3 py-1 border-l-2 border-black" data-testid={`cart-plus-${it.product_id}`}>+</button>
                                        </div>
                                        <button onClick={() => removeCart(it.product_id, it.size)} className="text-neutral-500 hover:text-[hsl(var(--accent))]" data-testid={`cart-remove-${it.product_id}`}><Trash2 className="w-4 h-4" /></button>
                                    </div>
                                </div>
                                <div className="font-display text-xl">₹{Math.round(it.price * it.quantity)}</div>
                            </div>
                        ))}
                    </div>
                    <div className="border-2 border-black p-6 h-fit md:sticky md:top-24" data-testid="cart-summary">
                        <div className="font-mono text-xs uppercase tracking-widest mb-4">Summary</div>
                        <div className="flex justify-between font-mono text-sm mb-2"><span>Subtotal</span><span>₹{Math.round(cart.subtotal)}</span></div>
                        <div className="flex justify-between font-mono text-xs text-neutral-500 mb-4"><span>Shipping</span><span>Free above ₹999</span></div>
                        <button onClick={() => nav("/checkout")} className="w-full bg-black text-white py-3 font-mono uppercase text-xs tracking-widest brutal-shadow" data-testid="checkout-btn">Checkout →</button>
                    </div>
                </div>
            )}
        </div>
    );
}
